import React, { Fragment } from 'react'
import { Pill, NotAvailable } from '@myxplor/ui'
import { confirmedStatus, draftStatus, warningStatus } from './helper'
import EnrolmentMessage from './enrolment-message'
import { BookingScheduleFromEnrolment } from '../booking-schedules'
import { EntitlementForEnrolment } from '../ccs-enrolment-entitlement'
import { EnrolmentOccurrences } from '../ccs-enrolment-occurrences'
import FlagPill from './flag-pill'

export const GovRecordBadges = ({ record }) => {
  return (
    <Fragment>
      <h4>
        ID:{' '}
        {draftStatus(record.status) ? (
          <NotAvailable name="ID" />
        ) : (
          record.gov_id
        )}
        &nbsp;
      </h4>
      <ul>
        <li>
          <Pill>{record.type}</Pill>
        </li>
        <li>
          {record.status === 'RECEIVED' ? (
            <div className="pill pill--received">{record.status}</div>
          ) : (
            <Pill
              ok={confirmedStatus(record.status)}
              warning={warningStatus(record.status)}
            >
              {record.status}
            </Pill>
          )}
        </li>
        <li>
          <FlagPill flags={record.flags} />
        </li>
        <EnrolmentMessage record={record} />
      </ul>
      <div className="enrolment-schedule__wrapper">
        <BookingScheduleFromEnrolment
          sessions={record.gov_record.Sessions || record.gov_record.sessions}
        />
      </div>
      <div className="ccs-enrolment-entitlement__wrapper">
        <EntitlementForEnrolment entitlement={record.entitlement} />
      </div>
      <div className="ccs-enrolment-entitlement__wrapper">
        <EnrolmentOccurrences enrolment={record} />
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/badges.jsx